module.exports = __webpack_public_path__ + "img/UTGOBL-9.ac8a30c2.jpg";